import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import { AccessNavigationRedirects } from './AccessNavigationRedirects';
import { RouteBodyClass } from './RouteBodyClass';

export const routeModule = createFrontendModule({
  pluginId: 'app',

  extensions: [
    AppRootWrapperBlueprint.make({
      name: 'route-body-class',
      params: {
        component: RouteBodyClass,
      },
    }),
    AppRootWrapperBlueprint.make({
      name: 'access-navigation-redirects',
      params: {
        component: AccessNavigationRedirects,
      },
    }),
  ],
});
